/* tslint:disable */
/* eslint-disable */
export * from './AnalysisApi';
export * from './ExerciseApi';
export * from './FavoriteApi';
export * from './GroupCodeApi';
export * from './MeasurementApi';
export * from './SessionApi';
export * from './StorageApi';
export * from './StripeApi';
export * from './SystemApi';
export * from './UserApi';
export * from './VocaliseAPIWebApi';
export * from './WarmupApi';
